<div
    [class.active]="isActive"
    class="drag-area"
    [class.disabled]="!targetFolder"
    (click)="fileUpload.click()"
    (dragover)="dragover($event)"
    (dragleave)="dragleave($event)"
    (drop)="drop($event)"
>
    {{ text }}
    <input
        type="file"
        multiple
        hidden
        [disabled]="!targetFolder"
        (change)="onFileSelected($event)"
        #fileUpload
    />
</div>
